<template>
  <b-table-simple
    bordered
    responsive
    class="mt-2 page-break"
    v-if="institution && institution.internal_use_id == 'duoc.cl'"
  >
    <b-thead>
      <b-tr>
        <b-th class="biblio-header">
          {{
            $t(
              "matterProgram.matterProgramView.resourcesByLearningEnvironment"
            ).toUpperCase()
          }}
        </b-th>
      </b-tr>
    </b-thead>
    <b-tbody>
      <b-tr>
        <b-td class="text-center align-middle">
          <div v-if="oldMatter">
            <RenderVHtml :content="oldMatter.fer_record"></RenderVHtml>
            <div v-if="allows_crud && oldMatter && !oldMatter.is_closed">
              <ButtonSmall
                v-if="can_update && allows_crud"
                tabindex="-1"
                :tooltip_text="
                  $t(
                    'matterProgram.matterProgramView.editResourcesByLearningEnvironment'
                  )
                "
                :click_button="
                  () => $bvModal.show(`edit-fer_record-modal-${oldMatter.id}`)
                "
                :class="`w-30`"
                :icon="'square'"
              ></ButtonSmall>
              <!-- <button-edit
                tabindex="-1"
                class="w-30"
                @click="$bvModal.show(`edit-fer_record-modal-${oldMatter.id}`)"
                v-b-tooltip.v-secondary.noninteractive="
                  'Editar Recursos por Ambiente de Aprendizaje (referencia Ficha FER)'
                "
              >
              </button-edit> -->
              <ContainerRichTextKlv3
                :id_modal="`edit-fer_record-modal-${oldMatter.id}`"
                :title_modal="
                  $t(
                    'matterProgram.matterProgramView.editResourcesByLearningEnvironment'
                  )
                "
                :size_modal="`lg`"
                :object_rich_text="oldMatter"
                :content_rich_text="oldMatter.fer_record"
                :show_last_modification="true"
                :permit_blank="true"
                @save="(content) => updateFerRecord(oldMatter, content)"
                @close="$bvModal.hide(`edit-fer_record-modal-${oldMatter.id}`)"
              >
              </ContainerRichTextKlv3>
              <!-- <b-modal
                :id="`edit-fer_record-modal-${oldMatter.id}`"
                title="Editar Recursos por Ambiente de Aprendizaje (referencia Ficha FER)"
                size="lg"
                hide-footer
              >
                <NewRichTextEditor
                  :Object="oldMatter"
                  :Text="oldMatter.fer_record"
                  @save="updateFerRecord"
                  @close="
                    $bvModal.hide(`edit-fer_record-modal-${oldMatter.id}`)
                  "
                ></NewRichTextEditor>
              </b-modal> -->
            </div>
          </div>
        </b-td>
      </b-tr>
    </b-tbody>
  </b-table-simple>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { toast } from "@/utils/utils";

export default {
  name: "ResourcesLearningEnvComponent",
  components: {
    // NewRichTextEditor: () => import("@/components/reusable/NewRichTextEditor"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
    ContainerRichTextKlv3: () =>
      import("@/components/reusable/ContainerRichTextKlv3"),
  },
  props: {
    oldMatter: {
      type: Object,
      required: true,
    },
    allows_crud: {
      type: Boolean,
      default: false,
    },
    can_update: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      institution: "getInstitution",
    }),
  },
  methods: {
    updateFerRecord(old_matter, text) {
      let payload = {
        matter_id: old_matter.id,
        item: {
          fer_record: text,
        },
      };
      this.$store.dispatch(names.PATCH_MATTER, payload).then(() => {
        toast(
          this.$t(
            "matterProgram.matterProgramView.resourcesByLearningEnvironmentUpdated"
          )
        );
      });
    },
  },
};
</script>

<style scoped>
table {
  width: 100%;
  table-layout: auto;
}
table td {
  border: 1px solid var(--kl-table-border) !important;
  text-align: center;
  vertical-align: middle;
  font-size: var(--secondary-font-size);
  padding: 2px 2px;
}
table th {
  vertical-align: middle;
  border: 1px solid var(--kl-table-border) !important;
  background-color: var(--kl-color-accent-medium) !important;
  color: var(--kl-text-on-primary) !important;
  font-size: var(--primary-font-size);
  padding: 2px 2px;
}
.th-header {
  background-color: var(--kl-color-accent-medium) !important;
  color: var(--kl-text-on-primary) !important;
  font-size: var(--primary-font-size);
}
@media print {
  .bibliography-content,
  .support-resource-content {
    text-overflow: ellipsis;
    word-wrap: break-word;
    max-width: 800px !important;
  }
}
</style>